import { RenderContextxikz99gtpuie as RenderContext } from './RenderContext.mjs';
import { SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { weight31wqab1913ly4 as weight } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_rem14pbkv8p42gid as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { sizeConstraints19w9rda6g3rqz as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function form(_this__u8e3s4, module_0, serializer, value) {
  var context = new (RenderContext())(serializer);
  module_0.form_gqhwsi_k$(context, value)(_this__u8e3s4);
}
function subrendererSelector(_this__u8e3s4, selectedRenderer, elementRenderers) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  var this_0 = themed(_this__u8e3s4, SubtextSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  var this_1 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (Space())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_1.willAddChild_hz2iwc_k$(element_0);
  element_0.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.select' call
  var this_2 = sizeConstraints(element, VOID, VOID, VOID, VOID, VOID, get_rem(0.75));
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (Select())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_2.willAddChild_hz2iwc_k$(element_1);
  var tmp = _Constant___init__impl__v45mub(elementRenderers);
  element_1.bind_64a41i_k$(selectedRenderer, new (Constant())(tmp), subrendererSelector$lambda);
  element_1.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_1);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
}
function subrendererSelector$lambda(it) {
  return it.get_name_woqyms_k$();
}
//region block: exports
export {
  form as form14yrrf1aazl4g,
  subrendererSelector as subrendererSelector1yvbedolu35d3,
};
//endregion

//# sourceMappingURL=helpers.mjs.map
